// material-ui
import { useTheme } from '@mui/material/styles';

import logo from 'assets/images/kambatime-logo.png';

export default function LogoMain() {
  return (
    <img src={logo} alt="KambaTime GPO" height="38" style={{ objectFit: 'contain', width: 'auto', maxWidth: '100%' }} />
  );
}
